// extracted by mini-css-extract-plugin
export default {"albumView":"albumView_albumView__7ZIzZ","albumHeading":"albumView_albumHeading__C3KS2","albumTrack":"albumView_albumTrack__kkbUl"};